import { getText } from '@/utils/i18nText'

// Lightweight zfgl-utils compatibility shim for the current front-end project
// Only implements the minimal functions used by the project to avoid pulling real dependencies.

// Session management: get/set token via sessionStorage.
export const session = {
  getToken() {
    try {
      return window.sessionStorage.getItem('TOKEN') || null
    } catch (e) {
      return null
    }
  },
  setLoginInfo(token) {
    try {
      if (token) {
        window.sessionStorage.setItem('TOKEN', token)
      }
    } catch (e) {
      // ignore
    }
  },
  clearLoginInfo() {
    try {
      window.sessionStorage.removeItem('TOKEN')
    } catch (e) {
      // ignore
    }
  }
}

// Request constants: the project mainly uses headers.greenChannel.
export const requestConst = {
  headers: {
    greenChannel: 'X-GREEN-CHANNEL'
  }
}

// Simple event bus: only provides $emit to avoid calling errors.
export const bus = {
  $emit() {
    // Used only to broadcast login/switch events; empty implementation is enough.
  }
}

// Logger utility: forwards directly to console.
export const logger = {
  error(...args) {
    // eslint-disable-next-line no-console
    console.error(...args)
  },
  info(...args) {
    // eslint-disable-next-line no-console
    console.info(...args)
  }
}

// Web utility: parse error information and return a friendly message.
export const webutils = {
  parseErrorMsg(error, defaultMsg) {
    if (defaultMsg) return defaultMsg
    if (error && error.response && error.response.data && error.response.data.message) {
      return error.response.data.message
    }
    if (error && error.message) return error.message
    return getText('common.requestFailed')
  }
}

// AES encryption placeholder: returns the original value to avoid dependency on real encryption.
export const aes = {
  encryptAes(value) {
    return value
  }
}

